var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61617_29148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.25 28.2889C42.25 23.23 40.4358 18.5968 37.4262 15C34.4515 22.7775 26.9294 28.302 18.1137 28.302C11.7405 28.302 6.04303 31.1897 2.25 35.7277C5.23656 43.4898 12.7527 49 21.5597 49C32.9868 49 42.25 39.7275 42.25 28.2889Z",
    fill: "#EBFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4262 15C36.874 16.444 36.1633 17.8095 35.3188 19.0771C37.0826 21.7117 38.1122 24.8797 38.1122 28.2889C38.1122 37.4395 30.7013 44.8576 21.5597 44.8576C13.8929 44.8576 7.44527 39.6386 5.56436 32.5558C4.34675 33.4888 3.23321 34.5513 2.25 35.7277C5.23656 43.4898 12.7527 49 21.5597 49C32.9868 49 42.25 39.7275 42.25 28.2889C42.25 23.23 40.4358 18.5968 37.4262 15Z",
    fill: "#55B1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 5H26.25V1H17.25V5Z",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7494 7.97288C22.2525 7.97288 22.7527 7.98248 23.25 8V5H20.25V8C20.7465 7.98248 21.2467 7.97288 21.7494 7.97288Z",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1008 13.3193C36.3793 13.5417 36.6484 13.7693 36.9098 14L40.25 11.3273L38.5906 10L35.25 12.6722C35.5381 12.8813 35.8228 13.0964 36.1008 13.3193Z",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 30L30.25 20",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 30L16.25 23",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.25 28.5C42.25 39.822 33.072 49 21.75 49C10.428 49 1.25 39.822 1.25 28.5C1.25 17.178 10.428 8 21.75 8C33.072 8 42.25 17.178 42.25 28.5Z",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.25 28.0002C38.25 36.8365 30.8625 44 21.7498 44C12.6371 44 5.25 36.8365 5.25 28.0002C5.25 19.1636 12.6371 12 21.7498 12C30.8625 12 38.25 19.1636 38.25 28.0002Z",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61617_29148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 50,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.80044085d2fbc021d4e83ca3819f10ce.svg";
export { ForwardRef as ReactComponent };